export default __webpack_public_path__ + "static/media/whiteLogo.5bc3d9e6.svg";